import React from 'react';
import UnifiedForgotPassword from '@components/UnifiedForgotPassword';
import { getHostname } from '@services/utils';

const ForgotPassword: React.FC = () => {
  const hostname = getHostname();
  const theme = hostname.includes('dxscontrols') ? 'light' : 'dark';
  
  return <UnifiedForgotPassword theme={theme} />;
};

export default ForgotPassword;
